import { FiCheck } from "react-icons/fi";
import clsx from "clsx";

import { useState, useEffect } from "react";

export default function Checkbox(props) {
  const { label, description, disabled } = props;
  const { onChange, onClickDisabled } = props;

  const [checked, setChecked] = useState(props.checked);

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  function handleClick(e) {
    // Don't toggle checkbox if a link was clicked
    if (e.target.tagName === "A" || e.target.closest("a")) {
      return;
    }

    if (disabled) return onClickDisabled && onClickDisabled();

    const newStatus = !checked;
    setChecked(newStatus);
    onChange(newStatus);
  }

  return (
    <div
      className={clsx(
        "checkbox-wrapper relative flex items-start cursor-pointer",
        { disabled }
      )}
      onClick={handleClick}
    >
      <div
        className={clsx(
          "checkbox mt-[2px] duration-100 flex-shrink-0 mr-2 w-5 h-5 border-2 border-primary-400 rounded-sm motion-safe:transition-colors",
          { checked, "bg-primary-400": checked }
        )}
      >
        <div className={clsx("text-white", { hidden: !checked })}>
          <FiCheck size={16} />
        </div>
      </div>
      <div className="flex flex-col">
        <span
          className="block"
          dangerouslySetInnerHTML={{ __html: label }}
        ></span>
        {description && (
          <span className="block text-emphasis-medium text-xs">
            {description}
          </span>
        )}
      </div>
    </div>
  );
}
